__turbopack_context__.v({
  "iconButton": "iconButton-module-scss-module__HLjBGa__iconButton",
  "primary": "iconButton-module-scss-module__HLjBGa__primary",
});
